import { render, staticRenderFns } from "./addPushRuleDialog.vue?vue&type=template&id=4d2b1364"
import script from "./addPushRuleDialog.vue?vue&type=script&lang=js"
export * from "./addPushRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./addPushRuleDialog.vue?vue&type=style&index=0&id=4d2b1364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports